<template>
  <a-popover :title="null" placement="right" overlayClassName="form-condition__popover">
    <template #content>
      <a-button class="button" type="link" @click="emit('add')">
        <a-tooltip title="Agregar condición" placement="right">
          <PlusOutlined class="button__icon" />
        </a-tooltip>
      </a-button>

      <a-button v-if="!hideDelete" class="button" type="link" @click="emit('delete')">
        <a-tooltip title="Eliminar condición" placement="right">
          <DeleteOutlined class="button__icon" />
        </a-tooltip>
      </a-button>
    </template>
    <slot />
  </a-popover>
</template>

<script setup lang="ts">
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons-vue";

defineProps<{
  hideDelete: boolean;
}>();

const emit = defineEmits<{
  (e: "add"): void;
  (e: "delete"): void;
}>();
</script>

<style scoped lang="sass">
.button
  padding: 0

  &__icon
    font-size: 16px
</style>

<style>
.form-condition__popover .ant-popover-arrow {
  display: none;
}

.form-condition__popover .ant-popover-content,
.form-condition__popover .ant-popover-inner {
  border-radius: 4px;
}

.form-condition__popover .ant-popover-inner-content {
  padding: 6px 10px !important;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
